namespace Matrix.Data {
    export interface AccountHoldingForm {
        InstanceCode: Serenity.StringEditor;
        AccountCode: Serenity.StringEditor;
        SubAccountCode: Serenity.StringEditor;
        SecurityId: Serenity.IntegerEditor;
        LongOrShort: Serenity.StringEditor;
        SourceCode: Serenity.StringEditor;
        AsAtDate: Serenity.DateEditor;
        LotCount: Serenity.IntegerEditor;
        TradeDate: Serenity.DateEditor;
        SettlementDate: Serenity.DateEditor;
        QtyFace: Serenity.DecimalEditor;
        QtyFaceOriginal: Serenity.DecimalEditor;
        LocalCurrencyCode: Serenity.StringEditor;
        PriceLocal: Serenity.DecimalEditor;
        PriceSource: Serenity.StringEditor;
        PriceUnderlyingLocal: Serenity.DecimalEditor;
        FxLocalToBase: Serenity.DecimalEditor;
        FxRateSource: Serenity.StringEditor;
        MarketValueLocal: Serenity.DecimalEditor;
        AccruedInterestLocal: Serenity.DecimalEditor;
        EffectiveExposureLocal: Serenity.DecimalEditor;
        CostLocal: Serenity.DecimalEditor;
        ProfitOrLossLocal: Serenity.DecimalEditor;
        PriceBase: Serenity.DecimalEditor;
        MarketValueBase: Serenity.DecimalEditor;
        AccruedInterestBase: Serenity.DecimalEditor;
        EffectiveExposureBase: Serenity.DecimalEditor;
        CostBase: Serenity.DecimalEditor;
        ProfitOrLossBase: Serenity.DecimalEditor;
        FxBaseToFirmCurrency: Serenity.DecimalEditor;
        TotalMarketValueBase: Serenity.DecimalEditor;
        TotalExposureBase: Serenity.DecimalEditor;
        MarketValueWeight: Serenity.DecimalEditor;
        ExposureWeight: Serenity.DecimalEditor;
        ModifiedDuration: Serenity.DecimalEditor;
        Yield: Serenity.DecimalEditor;
        RowId: Serenity.StringEditor;
        Version: StaticTextBlock;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
    }

    export class AccountHoldingForm extends Serenity.PrefixedContext {
        static formKey = 'Data.AccountHolding';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AccountHoldingForm.init)  {
                AccountHoldingForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DateEditor;
                var w3 = s.DecimalEditor;
                var w4 = StaticTextBlock;
                var w5 = ReadOnlyDateTime;

                Q.initFormType(AccountHoldingForm, [
                    'InstanceCode', w0,
                    'AccountCode', w0,
                    'SubAccountCode', w0,
                    'SecurityId', w1,
                    'LongOrShort', w0,
                    'SourceCode', w0,
                    'AsAtDate', w2,
                    'LotCount', w1,
                    'TradeDate', w2,
                    'SettlementDate', w2,
                    'QtyFace', w3,
                    'QtyFaceOriginal', w3,
                    'LocalCurrencyCode', w0,
                    'PriceLocal', w3,
                    'PriceSource', w0,
                    'PriceUnderlyingLocal', w3,
                    'FxLocalToBase', w3,
                    'FxRateSource', w0,
                    'MarketValueLocal', w3,
                    'AccruedInterestLocal', w3,
                    'EffectiveExposureLocal', w3,
                    'CostLocal', w3,
                    'ProfitOrLossLocal', w3,
                    'PriceBase', w3,
                    'MarketValueBase', w3,
                    'AccruedInterestBase', w3,
                    'EffectiveExposureBase', w3,
                    'CostBase', w3,
                    'ProfitOrLossBase', w3,
                    'FxBaseToFirmCurrency', w3,
                    'TotalMarketValueBase', w3,
                    'TotalExposureBase', w3,
                    'MarketValueWeight', w3,
                    'ExposureWeight', w3,
                    'ModifiedDuration', w3,
                    'Yield', w3,
                    'RowId', w0,
                    'Version', w4,
                    'CreatedBy', w4,
                    'CreatedWhen', w5,
                    'UpdatedBy', w4,
                    'UpdatedWhen', w5
                ]);
            }
        }
    }
}
